export class CreateAccountCommand {
    constructor(public userName: string,
                public password: string) {
    }
}

export class CreateAccountUserCommand {
    constructor(public hubName: string,
                public userName: string,
                public password: string) {
    }
}

export class EventCountCommand {
    public approved: number;
    public unapproved: number;
    public fbPage: any;
    public eventbritePage: any;
    public eventful: any;
    public serpGoogle: any;
    public lastRunTime: any;
    public spiderMonthlyCount: any;
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/commands/accounts/create.account.command.ts